module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA2UExURUdwTCopKv////KEpSkpKSkpKf////7v8/////////////KEpSkpKf///z87PL5thcLCwsHBwQlz1rUAAAALdFJOUwCxq60g8uAU56qo55WXkQAAAAlwSFlzAAAASAAAAEgARslrPgAAANlJREFUSMftl9EOgyAMRWFDC4MW/f+fHXGLRmhmkczEhPtoOLa0vUlR6u4yeggSDdqUrAxd8ILWQS6dwykwkw93uxQ6/5h+aGS1SScZWFjZ/8Hw9D+1h8FZ/Mg6UOB9BQwjbhqP4maww4m+DaQJ3XIgEtdfigVscTtJaBeY+OkgERxCLPONITBpz2vaMz7q4KxgdWkreKyteoGqK1g2JL6qVR2+D7z3s2/xs2/2sxjmLHkNzPn5moJxfu6z3eHu5+7n28HmNLwu60frIzHLetMzoemB0vQ0OqE32BZnqRLfDNMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/category/c_2.png
// module id = 790
// module chunks = 0